/* eslint-disable no-console */

import { DialogProgrammatic as Dialog, ToastProgrammatic as Toast } from 'buefy'
import { get } from 'lodash'
import { objectToSnake } from 'ts-case-convert'

console.log('************************')
console.log('* dashboardStore Startup')
if (process.env.RELIEF_URL) {
  console.log(
    '* process.env.RELIEF_URL is properly set',
    process.env.RELIEF_URL
  )
} else {
  console.error('* process.env.RELIEF_URL is MISSING')
}
if (process.env.PROFILE_URL) {
  console.log(
    '* process.env.PROFILE_URL is properly set',
    process.env.PROFILE_URL
  )
} else {
  console.error('* process.env.PROFILE_URL is MISSING')
}
console.log('************************')

const onboardingSchema = [
  {
    name: 'identity',
    reqFields: ['firstName', 'lastName', 'dob', 'tosAcceptanceDate'],
  },
  { name: 'address', reqFields: ['address1', 'city', 'state', 'zip'] },
  { name: 'avatar', reqFields: ['avatarUrl'] },
  {
    name: 'security',
    reqFields: ['question', 'response'],
    minOccurence: 2,
    maxOccurence: 2,
  },
  { name: 'research', reqFields: ['researchOptInDate'] },
  { name: 'final', reqFields: [] },
]

const state = () => ({
  features: {
    DASHBOARD_PROFILE: process.env.DASHBOARD_PROFILE === 'true',
    DASHBOARD_ADDRESS: process.env.DASHBOARD_ADDRESS === 'true',
    DASHBOARD_PAYMENT_METHODS: process.env.DASHBOARD_PAYMENT_METHODS === 'true',
    DASHBOARD_APPLICATIONS: process.env.DASHBOARD_APPLICATIONS === 'true',
  },
  securityQuestionsOptions: [
    { question: 'onboarding_sec_ques_born_city' },
    { question: 'onboarding_sec_ques_first_street' },
    { question: 'onboarding_sec_ques_oldest_cousin' },
    { question: 'onboarding_sec_ques_partner_meet' },
    { question: 'onboarding_sec_ques_first_pet' },
    { question: 'onboarding_sec_ques_childhood_hero' },
    { question: 'onboarding_sec_ques_fav_movie' },
    { question: 'onboarding_sec_ques_city_mom' },
    { question: 'onboarding_sec_ques_heirloom' },
    { question: 'onboarding_sec_ques_city_dad' },
  ],
  loading: [],
  loaderCounterProduct: 0,
  loaderCounterAccount: 0,
  applications: undefined,
  stripeAccountStatus: '',
  stripeAccountId: '',
  confirmationType: '',
  /* address */
  addresses: undefined,
  addressTypes: [],
  editAddress: {
    editing: false,
    address: undefined,
  },
  /* payment */
  paymentProducts: undefined,
  paymentAccounts: undefined,
  payments: undefined,
  paymentTypes: [],
  editPayment: {
    editing: false,
    payment: undefined,
  },
  selectedPayment: undefined,
  activeTab: 0,
  dashboardItemSelected: 'profile',
  replacementCardConfirm: false,
  stripeCards: undefined,
  onboarding: {
    onboardingSteps: undefined,
    onboardingSchema,
  },
  authClaims: {},
  panelDisplayed: 'profile',
  newCode: '',
  family: [],
  householdMembers: [],
  householdMembersLoaded: false,
  addNewHouseholdMember: false,
  editMemberUuid: undefined,
  menuActive: true,
  newDob: '',
  i18n: {
    en: {
      address__make_primary: 'Make Primary',
      address_button_new: 'Add a new address',
      address_nickname_placeholder: 'Home, Office, etc. (Optional)',
      address_nickname: 'Nickname (optional)',
      address_save: 'Save Address',
      address_saved: 'Address Saved',
      address_type: 'Address Type',
      address_updated: 'Your address has been updated.',
      application__click_to_select: 'Click to select...',
      applications: 'Application Status',
      are_you_sure_you_want_to_delete: 'Are you sure you want to delete',
      billing_address: 'Billing Address',
      cancel: 'Cancel',
      confirm: 'Confirm',
      review__details: 'Review Details',
      email__confirmation:
        'Notification regarding this will be sent to email. You can change this in future under notification settings.',
      dashboard__address: 'Address',
      dashboard__mailing_address: 'Address',
      dashboard__profile: 'Profile',
      dashboard__notifications: 'Notifications',
      dashboard__security: 'Security Questions',
      dashboard__optin: 'Opt Ins',
      dashboard__household: 'Household',
      dashboard__applications__amount: 'Amount',
      dashboard__applications__date_updated: 'Date Updated',
      dashboard__applications__payment_type: 'Type',
      dashboard__applications__program: 'Program',
      dashboard__applications__status: 'Status',
      dashboard__applications__submit_date: 'Submit Date',
      dashboard__no_applications_yet:
        "You haven't submitted any applications yet.",
      dashboard__payment_methods: 'Payment Options',
      dashboard__restricted_account_button: 'Verify Account',
      verifying_address: 'Verify Address',
      dashboard__restricted_account_text:
        'Our payment processor has restricted your account. This typically happens when the processor cannot verify your identity and requires additional information before you are able to receive a cash transfer. Users are typically successful when they upload a government-issued ID, provide their date of birth and fill out the last 4 digits of their social security number (or ITIN). Please click below to start verifying your account.',
      dashboard__restricted_account_title: 'Your account is restricted',
      dashboard__support_link_text: 'Support Center',
      dashboard__support_link_url:
        'https://fund.support.uptogether.org/hc/en-us',
      select__shipping_address: 'Select Shipping Address',
      select__shipping_address_subtitle:
        'This address is used to ship the card to your location',
      dashboard__support_text:
        'If you have questions about your application status, please visit the',
      dashboard__unavailable:
        "We're sorry, but application status is currently unavailable. Please try again later.",
      dashboard__contact: 'Contact',
      dashboard__contact_methods_text_1:
        'Add additional contact methods to your account. You can use any of these contact methods to sign in.',
      dashboard__contact_methods_text_2:
        'Only contact methods designated as ‘primary’ receive notifications.',
      dashboard: 'Dashboard',
      notification_general_preferences: 'General Preferences',
      notification_specific_preferences: 'Specific Preferences',
      tool_tip_notifications:
        'Choose how you’d like to receive UpTogether updates. For text message notifications, standard carrier messaging rates may apply.',
      tool_tip__specific_notifications:
        'Choose which UpTogether updates you’d like to get.',
      payment_notification: 'Payment Notification',
      survey_updates: 'Survey Notices',
      survey_updates_description:
        'Get notified when a survey becomes available',
      financial_updates: 'Financials Updates',
      financial_updates_description:
        'This includes application status, messages from fund partners, and other important messages',
      research_updates: 'Research and Story Requests',
      uptogether_updates: 'UpTogether General',
      text_notifications: 'Text Message Notifications',
      email_notifications: 'Email Notifications',
      save_preferences: 'Save',
      security_title: 'Security',
      security_subtitle: 'Security Questions',
      tool_tip_security:
        'If you lose access to your account, you can contact UpTogether to verify your identity with these questions.',
      notification_preferences_saved: 'Notification Preferences Saved',
      notification_disabled_msg: 'Contact method not added yet.',
      delete: 'Delete',
      text: 'Text',
      email: 'Email',
      phone: 'Phone',
      edit: 'Edit',
      manage: 'Manage',
      created: 'Created',
      add_email: 'Add Email',
      add_phone: 'Add Phone Number',
      manage_contact: 'Manage Contact Methods',
      onboarding_save: 'Save',
      onboarding_next: 'Save & Continue',
      other: 'other',
      dashboard_optin_opportunities: 'Opt In Opportunities',
      payments__card_activation: 'Card Activation',
      payments__cvc: 'CVC',
      payments__expiration_date: 'Expiration Date',
      payments__address1_placeholder: '123 Main Street',
      payments__address1: 'Address 1',
      payments__address2_placeholder: '#1003',
      payments__address2: 'Address 2',
      payments__city_placeholder: 'Seattle',
      choose__shipping_address:
        'Selecting this option will make this address as a shipping address. Are you sure to proceed?',
      payments__city: 'City',
      payments__dob: 'Date of Birth',
      payments__first_name_placeholder: 'Jane',
      payments__first_name: 'First Name',
      payments__email__vi_placeholder: 'Jane@gmail.com',
      payments__email_vi: 'email',
      payments__last_name_placeholder: 'Doe',
      payments__last_name: 'Last Name',
      payments__state_placeholder: 'WA',
      payments__state: 'State',
      payments__user_name_placeholder: 'janedoe',
      payments__user_name: 'User Name',
      payments__zip_placeholder: '98104',
      payments__zip: 'Zip/Postal Code',
      payments_zip_error: 'Must exactly contain 5 digits',
      payments__select_an_existing_account: 'Select a payment method',
      payments__or_add_a_new_account: 'Add a new payment method',
      payments__how_to_recieve_funds:
        'How would you like to receive your funds?',
      payments__direct_deposit_to_bank_account:
        'Direct Deposit to Bank Account',
      payments__physical_debit_card: 'Request a UpTogether Physical Card',
      payments__virtual_debit_card: 'Request a UpTogether Virtual Card',
      payments__paypal: 'Transfer to PayPal',
      payments__venmo: 'Transfer to Venmo',
      payments__direct_deposit: 'Direct Deposit',
      payments__account_number: 'Account Number',
      payments__bank_accountholders_full_name: "Primary Account Holder's Name",
      payments__bank_accountholders_full_name_placeholder: 'Jane Q. Doe',
      payments__bank_account_number: 'Bank Account Number',
      payments__confirm_bank_account_number: 'Confirm Bank Account Number',
      payments__bank_account_number_placeholder: '000123456789',
      payments__auto_pay_title: 'Automatic Deposit Settings',
      payments__auto_pay_description:
        'Turn on automatic deposits from your UpTogether Personal Fund Account to your preferred payment receipt method. You won’t have to manually withdraw funds from accepted offers and research payments.',
      payments__preferred_payment_account: 'Preferred Payment Receipt Method',
      payments__settings_updated: 'Settings Updated',
      payments__issuing_confirmation_title: 'Confirm payment receipt method',
      payments__issuing_confirmation_physical_1:
        'If you select this method, future payments will be transferred to your UpTogether physical card. You may change this any time.',
      payments__issuing_confirmation_virtual_1:
        'If you select this method, future payments will be transferred to your UpTogether virtual card. You may change this any time.',
      payments__physical_cards: 'physical cards',
      payments__virtual_cards: 'virtual cards',
      payments__paypal_view: 'PayPal',
      payments__venmo_view: 'Venmo',
      payments__card: 'card',
      payments__issuing_confirmation_text_4: 'Before you confirm,',
      payments__issuing_confirmation_text_5: 'please read these FAQs',
      payments__issuing_confirmation_text_6: 'to understand how',
      payments__issuing_confirmation_physical_2:
        'physical cards can and can’t be used.',
      payments__issuing_confirmation_virtual_2:
        'virtual cards can and can’t be used.',
      payments__issuing_confirmation_btn: 'Confirm payment method',
      payments_confirmation_message: 'Confirm Payment Method',
      security__settings_updated: 'Security Answers Updated',
      payments__physical_card: 'Physical Card',
      payments__card_type: 'Card Type',
      physical: 'physical',
      activate: 'activate',
      payments__virtual_card: 'Virtual Card',
      virtual: 'virtual',
      payments__view_card_details: 'View Card Details',
      payments__how_would_you_like_to_receive_your_funds:
        'How would you like to receive your funds?',
      payments__information_header: 'Information about you',
      payments__issuing_name_confirm:
        'Please confirm your name; it will be printed on your card.',
      payments__stripe_card_billing_address:
        'Your card will use this address as the billing address when making online purchases.',
      payments__stripe_card_issuing_digital:
        'I would like to receive my funds via a digital card available instantly after my application is approved',
      payments__stripe_card_issuing_physical:
        'I would like to receive my funds via a physical card delivered to my address within 6-8 days after my application is approved',
      payments__state_placeholder_long: 'Select a State',
      payments__bank_header: 'Bank Information',
      payments__bank_name: 'Bank Name',
      payments__bank_routing_number: 'Routing Number',
      payments__confirm_bank_routing_number: 'Confirm Routing Number',
      payments__bank_routing_number_placeholder: '110000000',
      payments__are_you_sure: 'Are you sure?',
      payments__email: 'Email associated with PayPal account',
      payments__phone_number: 'Phone number associated with Venmo account',
      payments__vi_email: 'Email associated with  VI PayPal account',
      payments__vi_phone_number:
        'Phone number associated with VI Venmo account',
      payments__vi_venmo_phone_prefill:
        'Please go to the Contact Information page on your profile and add the phone number you will use for Venmo',
      payments__venmo_add_phone_description:
        'For your security, we need to verify the phone number linked with your Venmo account. Enter the phone number below to receive a verification code via text message.',
      primary: 'primary',
      shipping: 'shipping',
      required: 'Required',
      special_chars_name: 'Error - please remove any special characters',
      dob_eighteen: 'User must be 18 years old or older to sign up.',
      save: 'Save',
      add: 'Add',
      onboarding__error: "Oops, we've encountered a problem. Please try again.",
      notification_financial_updates_off_message:
        'Are you sure you want to turn off Financial Updates? You will no longer receive notices about cash offers that may be available to you.',
      notification_financial_updates_off_confirm: 'Turn Off',
      account_creation:
        ', then come back to this page to finish setting up this payout method.',
      change_venmo_phone_number_message: 'Entered the wrong phone number? ',
      change_phone_number: 'Enter the number again',
      code_receive_text: "Didn't receive the code?",
      disconnect: 'Disconnect',
      dashboard__code_confirmation: 'Enter Code:',
      dashboard__resend_code: 'Resend Code',
      dashboard__send_code: 'Send Code',
      dashboard__sent_code_confirmation_1: 'A code was sent to',
      dashboard__sent_code_confirmation_2:
        '. Please verify the number by entering the code you received below. The code expires in 5 minutes.',
      dashboard_venmo_confirm_code: 'Connect with Venmo',
      dashboard_enter_the_code: 'Enter the code',
      dashboard_venmo_one_time_code_error_status:
        'Invalid One-Time Code entered, please try again.',
      dashboard_venmo_session_expired:
        'The code you entered has expired. Please try again.',
      dashboard_venmo_one_time_code_expired:
        'The code you entered has expired. Please Resend Code to try again.',
      disabled: 'Disabled',
      error_verifying_venmo_phone_number:
        "We couldn't verify the phone number associated with your Venmo account. Please try again.",
      error_verifying_venmo:
        'There was a problem verifying the phone number associated with your Venmo account. Please try again later.',
      one_time_code: 'One Time Code Verification',
      payment_disconnect_message_title: 'Confirm disconnection',
      payment_disconnect_confirmation:
        'Are you sure you want to disconnect your ',
      payment_disconnect_confirmation_message:
        'If you choose to disconnect, you will no longer be able to receive payments to this account.',
      paypal_email_address: 'Email Address',
      paypal_email_address_message:
        'to verify the email associated with your PayPal account for any troubleshooting needs.',
      paypal_information_header: 'Information we collect:',
      paypal_notification_message:
        'Your contact method will default to the following unless you change it:',
      paypal_payer_id: 'PayPal account ID (payer ID)',
      paypal_payer_id_message:
        'to identify your PayPal account for transferring funds.',
      paypal_verification_status: 'Account verification status',
      paypal_verification_status_message:
        'to check if you have a verified PayPal account with all the limitations lifted.',
      paypal_account_creation_title: "Don't have a PayPal account yet?",
      paypal_account_disconnect_message: 'PayPal account?',
      sign_up: 'Create one first',
      under_18_message:
        'If you are under age 18, please set up your account with a Parent/Guardian as the primary account holder.',
      venmo_add_phone_message_header: 'Venmo Phone Number',
      venmo_account_creation_title: "Don't have a Venmo account yet?",
      venmo_account_disconnect_message: 'Venmo account?',
      yes: 'Yes',
      // Payment method redesign
      payments__add_payout_method_error_message:
        'There are no payout methods currently enabled for this account. Please try again later, or contact support.',
      payments__add_payout_method: 'Add Payout Method',
      payments__payout_method_subtitle:
        'Choose the method you would like to add.',
      payments__select_primary_payout_method: 'Select a Primary Payout Method',
      payments__change_primary_payout_method: 'Change Payout Method',
      payout_method_title_message: 'Welcome to your Payout Methods',
      payout_method_subtitle1_message:
        "Let's take some time to set up your Primary payout method.",
      payout_method_subtitle2_message:
        'In UpTogether your primary payout method can be:',
      payout_method_direct_deposit: 'Bank Account (Direct Deposit)',
      payout_method_debit_card: 'UpTogether Debit Card (Physical or Virtual)',
      payout_method_account: 'Paypal or Venmo Account',
      payout_method_payment_instruction:
        'This is where we will send your payouts.',
      payout_method_note:
        'NOTE: setting up a primary payout method does NOT guarantee selection for funds.',
      primary_payout_method_setup_message:
        'Are you ready to set up your primary payout method?',
      not_now: 'Not now',
      setting_up_preferred_method_title_message:
        'Setting up Your Primary Payout Method',
      setting_up_preferred_method_subtitle_message:
        'Choose the method which best fits your needs',
      payments__virtual_physical_cards: 'Virtual/Physical Card',
      payments__paypal_account: 'PayPal Account',
      payments__venmo_account: 'Venmo Account',
      payments__vi_reloadable_virtual_card: 'Uptogether Virtual Card',
      payments__vi_reloadable_physical_card: 'Uptogether Physical Card',
      payments__vi_paypal_account: 'VI PayPal Account',
      payments__vi_venmo_account: 'VI Venmo Account',
      payments__vi_ach: 'ACH / Direct Deposit',
      payment__vi__address__disabled__all_1: 'All addresses are',
      payment__vi__address__disabled__some_1: 'Some addresses are',
      payment__vi__address__disabled__some_2:
        'since they exceed the maximum character limit set by the payment vendor. Please',
      payment__vi__address__disabled__some_3: 'or add a new shipping address',
      payment__vi__address_edit: 'edit the address',
      payments__selection_title: 'You Have Selected',
      payments__method_information_message: 'Learn more about this option here',
      payments__method_card_information_message1:
        'This is how your name will appear on your card',
      payments__method_card_information_message2:
        'This is the billing address your card will use for purchases',
      back: 'Back',
      payments__institution_name: 'Institution Name',
      payments__institution_name_placeholder: 'Wells Fargo',
      payments_method_review_title_message: 'Review Your Information for',
      dashboard__payout_details: 'Payout Details',
      payments__method: 'Method',
      payments__method_primary: 'Primary',
      payments__method_type: 'Type',
      payments__method_created: 'Date Added',
      payments__bank_accountholder: 'Account Holder',
      payments__bank_account_type: 'Account Type',
      payments_success_page_title: 'Congratulations!',
      payments__success_page_subtitle1: 'You have successfully set',
      payments__success_page_subtitle2: 'as your payout method.',
      payments__success_page_primary_subtitle2:
        'as your primary payout method.',
      payments__virtual_debitcard: 'Virtual Debit Card',
      payments__physical_debitcard: 'Physical Debit Card',
      payments__debit_card_message: 'You Have Selected Debit Card',
      payments__debit_card: 'Debit Card',
      payments__name: 'Name',
      payments__physical_card_message:
        '<b>Note: Physical cards typically take about 10 business days to arrive at the address you enter.</b>',
      continue: 'Continue',
      payments_card_holder_name: 'YOUR NAME HERE',
      balance: 'balance',
      payments__remove_method: 'Remove Method',
      payments__remove_method_message: 'Delete method and data off UpTogether',
      payments__make_primary_method: 'Make Primary Method',
      payments__make_primary_method_message:
        'Make account primary payout method',
      payments__view_details: 'View Details',
      payments__view_details_message: 'View or edit method details',
      payments__show_card: 'Show Card',
      payments__show_card_message: 'Show debit card info',
      payments__hide_card: 'Hide Card',
      payments__hide_card_message: 'Hide debit card info',
      payments__physical_card_dispatch_message:
        'Your physical card will ship to the billing address you provided. Once you register your card, details will become available here.',
      payments__vi_virtual_card_dispatch_message:
        'Create an account following the email from Virtual Incentive. Once you register, your card details will become available here.',
      payments__vi_physical_card_dispatch_message:
        'Your physical card will ship to the billing address you provided. Once you register, your card details will become available here.',
      financials_home: 'Financials Home',
      view_payout_method: 'View Payout Method',
      payments__updated_message: 'Your changes have been successfully changed!',
      payments__stripe_direct_deposit_error_message:
        'We were unable to confirm your details with your institution, your changes were not saved. Confirm your banking info and try again.',
      payments__stripe_card_error_message:
        'We were unable to confirm your details, your changes were not saved.',
      payments__confirm_method: 'Confirm Method',
      payments__make_a_change: 'Make a Change',
      payments__change_method_message1: 'Want to change your method?',
      payments__change_method_message2: 'Cancel setup',
      dashboard__payout_options: 'Payout Method',
      tool_tip_help: 'Help me find this',
      save_and_review: 'Save & Review',
      stripe_payment_error_message:
        'Looks like there was an issue verifying your bank information. Please ensure your details are correct.',
      payments__cvv: 'CVV',
      payments__city_validation_message: 'Please enter a valid City',
      payments__primary_account_disconnection_message:
        'You are about to remove your primary method.<br /><br /> Your payout method will now default to the next payout you have on file.<br /><br /> If no method is found you will need to add another in order to receive funds in the future. Otherwise, you are at risk of losing your payout.',
      // One time application redesign
      payments__street_address: 'Street Address',
      payments_apt_number: 'Apt/Suite/Number',
      payments__switch_method: 'Need to Switch Methods?',
      click_here: 'Click here',
      need_help: 'Need help?',
      primary_stripe_account_deletion:
        'If you want to delete this method, please select a different payout method or create a new one and select it as your primary first.',
      payments__bank_account_numbers_mismatch_message:
        'Account Numbers must match!',
      payments__bank_account_numbers_length_not_in_range_message:
        'Account Number must be between 5 and 17 characters.',
      payments__routing_numbers_mismatch_message: 'Routing Numbers must match!',
      payments__routing_numbers_length_not_in_range_message:
        'Routing Number must be exactly 9 characters.',
      checking_savings: 'Checking/Savings',
      payments__primary_method_subtitle1: 'You have chosen',
      payments_primary_method_confirmation_message:
        'Are you sure you want to continue with this method?',
      payments_primary_method_disbaled_message:
        'The current Primary Method is disabled. Please select a different payout method to continue submitting the application.',
      payment_setup_primary_method: 'Please setup a primary payout method.',
      payments__direct_deposit_help_message_1:
        'To set up your Direct Deposit, you will need a:',
      payments__direct_deposit_help_message_2:
        'Checking account number (recommended) or savings account number',
      payments__direct_deposit_help_message_3: 'Bank routing number',
      payments__direct_deposit_help_message_4:
        'Once the direct deposit from UpTogether is successfully completed, the transferred money can be used just like any other funds in your bank account.',
      payments__issuing_card_help_message_1:
        'UpTogether Physical Cards function like a prepaid gift card that can be accepted anywhere you would use debit or credit cards.',
      payments__issuing_card_help_message_2:
        'This card can not be used for cashback purposes at registers, withdrawals from ATMs, or money transfers.',
      payments__issuing_card_help_message_3:
        'UpTogether Physical Cards will be issued and typically take up to 10 business days to arrive by mail.',
      payments__issuing_card_help_message_4:
        'UpTogether Virtual Cards can be used online anywhere that accepts online debit or credit card payments.  This card can not be used directly for in-store purchases, cashback purposes, withdrawals from ATMs, or money transfers.',
      payments__issuing_card_help_message_5:
        'The UpTogether Virtual Card will already be activated and funds are typically available on the card within 2-3 business days of being issued.',
      payments__paypal_account_help_message_1:
        'Use your existing Paypal account, or create one now',
      payments__paypal_account_help_message_2:
        'All you need is to make sure your email address is correct',
      payments__paypal_account_help_message_3:
        'If your email address linked to Uptogether has changed, update your profile before you get started',
      payments__venmo_account_help_message_1:
        'Use your existing Venmo account, or create one now',
      payments__venmo_account_help_message_2:
        'Make sure your phone number is correct',
      payments__venmo_account_help_message_3:
        'If your phone number linked to Uptogether has changed, update your profile before you get started',
      payments__vi_reloadable_virtual_card_help_message_1:
        'UpTogether Virtual cards are reloadable and can be used online anywhere that accepts online debit or credit card payments.',
      payments__vi_reloadable_virtual_card_help_message_2:
        'Maximum Balance: $10,000',
      payments__vi_reloadable_physical_card_help_message_1:
        'UpTogether Physical cards are sent in the mail and once activated, are reloadable and accepted anywhere that accepts online debit or credit card payments.',
      payments__vi_reloadable_physical_card_help_message_2:
        'UpTogether Physical cards can be used for ATM withdrawals or cashback purchases (limited to $300 per withdrawal and $600 per day)',
      payments__vi_reloadable_physical_card_help_message_3:
        'Maximum Balance: $10,000',
      payments__vi_paypal_help_message_1:
        'Use your existing Paypal account, or create one now',
      payments__vi_paypal_help_message_2:
        'All you need is to make sure your email address is correct',
      payments__vi_paypal_help_message_3:
        'If your email address linked to Uptogether has changed, update your profile before you get started',
      payments__vi_venmo_help_message_1:
        'Use your existing Venmo account, or create one now',
      payments__vi_venmo_help_message_2:
        'All you need is to make sure your phone number is correct',
      payments__vi_venmo_help_message_3:
        'If your phone number linked to Uptogether has changed, update your profile before you get started',
      payments__vi_ach_help_message_1:
        'Bank transfers via Direct Deposit require proof of ID, and the bank routing number to either a checking account (recommended) or savings account',
      payments__vi_ach_help_message_2:
        'Completed bank transfers via Direct Deposit can be used like all other funds in your bank account',
      payments__name_validation_message: 'Your name can only contain letters.',
      payments__email_validation_message: 'Enter a valid email address.',
      dashboard__knowledgebase_document_url:
        'https://docs.google.com/document/d/1v_cVemH7SnFLl9hSdPso6RjHIfI1ploo_jWsfFE-kgE/edit',
      payments__confirmation_physical_1:
        'If you select this method, future payments will be transferred to your UpTogether physical card. You may change this any time.',
      payments__confirmation_virtual_1:
        'If you select this method, future payments will be transferred to your UpTogether virtual card. You may change this any time.',
      payments__confirmation_connect_1:
        'If you select this method, future payments will be transferred to your UpTogether direct deposit bank account. You may change this any time.',
      payments__confirmation_physical_2:
        'physical cards can and can’t be used.',
      payments__confirmation_virtual_2: 'virtual cards can and can’t be used.',
      payments__confirmation_connect_2:
        'direct deposit bank accounts can and can’t be used.',
      payments__confirmation_text_4: 'Before you confirm,',
      payments__confirmation_text_5: 'please read these FAQs',
      payments__confirmation_text_6: 'to understand how',
      payments__direct_deposit_bank_account: 'direct deposit bank account',
      vi_add_shipping_address: 'Add Shipping Address',
      smarty_address_verification_failure:
        'Error verifying address. Please try again later.',
      smarty_address_verified_invalid:
        'We were unable to find your address. Please try again with a valid US address. If this continues, please contact our Support team.',
      return__to__application: 'Return to Application',
      set__email_to_create_vi_modalities:
        'You don’t have an email linked to your account. This payment vendor requires email to set up. Please add an email to your account to process further.',
      set__phone_to_create_vi_modalities:
        'You don’t have an phone number linked to your account. This payment vendor requires phone number to set up. Please add a phone number to your account to continue.',
      update_profile_settings:
        'This payment method requires first name and last name. Please update these in your profile settings and then try again.',
      profile_settings: 'Go to profile settings',
    },
    es: {
      activate: 'Activar',
      address__make_primary: 'Hacer primaria',
      address_button_new: 'Ingrese un nuevo domicilio',
      address_nickname: 'Apodo (Opcional)',
      address_nickname_placeholder: 'Hogar, oficina, etc. (opcional)',
      address_save: 'Guardar Domicilio',
      address_saved: 'Dirección guardada',
      address_type: 'Tipo de dirección',
      address_updated: 'Su dirección ha sido actualizada.',
      application__click_to_select: 'Clic para seleccionar...',
      applications: 'Estado de la aplicación',
      are_you_sure_you_want_to_delete: 'Esta seguro/a que quiere eliminar',
      billing_address: 'Dirección de Envio',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      review__details: 'Revisar detalles',
      email__confirmation:
        'Se enviará una notificación al respecto a email. Puede cambiar esto en el futuro bajo configuración de notificaciones.',
      dashboard: 'Tablero',
      dashboard__tool_tip_contact: '',
      dashboard__contact: 'Contacto',
      dashboard__contact_methods_text_1:
        'Agregue métodos de contacto adicionales a su cuenta. Puede utilizar cualquiera de estos métodos de contacto para iniciar sesión.',
      dashboard__contact_methods_text_2:
        "Solo los métodos de contacto designados como 'principales' reciben notificaciones.",
      dashboard__address: 'Domicilio',
      dashboard__mailing_address: 'Domicilio',
      dashboard__applications__amount: 'Monto',
      dashboard__applications__date_updated: 'Fecha Actualizada',
      dashboard__applications__payment_type: 'Metodo',
      dashboard__applications__program: 'Programa',
      dashboard__applications__status: 'Estatus',
      dashboard__applications__submit_date: 'Fecha Enviada',
      dashboard__no_applications_yet: 'Aún no has sometido ninguna solicitud.',
      dashboard__payment_methods: 'Opciones de Pago',
      dashboard__profile: 'Perfil',
      dashboard__restricted_account_button: 'Verificar Cuenta',
      verifying_address: 'Verificar la dirección',
      dashboard__restricted_account_text:
        'Nuestro procesador de pagos ha restringido su cuenta. Esto suele suceder cuando el procesador no puede verificar su identidad y requiere información adicional antes de que se pueda transferir su deposito. Las cuentas suelen tener éxito en remover lo restringido cuando la persona sube una identificación emitida por el gobierno, proporciona su fecha de nacimiento, y los últimos 4 dígitos de su número de seguro social (o numero de ITIN). Haga clic a continuación para comenzar a verificar su cuenta.',
      dashboard__restricted_account_title: 'Su cuenta esta restringida',
      dashboard__support_link_text: 'Centro de Apoyo',
      dashboard__support_link_url: 'https://fund.support.uptogether.org/hc/es',
      select__shipping_address: 'Seleccione la dirección de envío',
      select__shipping_address_subtitle:
        'Esta dirección se utiliza para enviar la tarjeta a usted',
      dashboard__support_text:
        'Si tiene alguna pregunta sobre el estatus de su solicitud, favor de visitar al',
      dashboard__unavailable:
        'Lo sentimos, pero el estado de su aplicación no está disponible actualmente. Por favor, inténtelo de nuevo más tarde.',
      dashboard__household: 'Familia',
      dashboard__notifications: 'Notificaciones',
      dashboard__security: 'Preguntas de Seguridad',
      notification_general_preferences: 'Preferencias Generales',
      notification_specific_preferences: 'Preferencias Específicas',
      tool_tip__specific_notifications:
        'Escoga cuales de las actualizaciones de UpTogether quisiera recibir.',
      tool_tip_notifications:
        'Escoga cómo quiere recibir actualizaciones de UpTogether. Para notificaciones por mensaje de texto, los cargos de su proveedor de servicio aplican.',
      tool_tip_security:
        'Si usted pierde acceso a su cuenta, usted puede contactar a UpTogether para verificar su identidad con estas preguntas.',
      payment_notification: 'Notificación de pago',
      survey_updates: 'Avisos de encuestas',
      survey_updates_description:
        'Recibir notificaciones en cuanto se vuelva disponible alguna encuesta.',
      financial_updates: 'Actualizaciones financieras',
      financial_updates_description:
        'Incluye estado de solicitud, mensajes de los colaboradores del fondo, y otros mensajes importantes.',
      research_updates:
        'Participar en investigaciones o compartir su testimonio',
      uptogether_updates: '',
      text_notifications: 'Notificaciones por Mensaje de Texto',
      email_notifications: 'Notificaciones por Correo Electrónico',
      save_preferences: 'Guardar',
      notification_preferences_saved:
        'Las preferencias de las notificaciones han sido guardados',
      notification_disabled_msg: 'Método de contacto aún no agregado.',
      security_title: 'Seguridad',
      security_subtitle: 'Preguntas de Seguridad',
      delete: 'Eliminar',
      edit: 'Editar',
      manage: 'Ajustes',
      created: 'Creado',
      text: 'Texto',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      add_email: 'Agregar email',
      add_phone: 'Agregar el número de teléfono',
      manage_contact: 'Administrar los métodos de contacto',
      onboarding_save: 'Guardar',
      onboarding_next: 'Guardar y Continuar',
      other: 'Otro',
      payments__account_number: 'Número de Cuenta',
      payments__address1: 'Dirección 1',
      payments__address1_placeholder: '123 Main Street',
      payments__address2: 'Dirección 2',
      payments__address2_placeholder: '#1003',
      payments__bank_account_number: 'Número de cuenta bancaria',
      payments__confirm_bank_account_number:
        'Confirme el número de cuenta bancaria',
      payments__bank_account_number_placeholder: '000123456789',
      payments__bank_accountholders_full_name:
        'Nombre del titular de la cuenta principal',
      payments__bank_accountholders_full_name_placeholder: 'Jane Q. Doe',
      payments__bank_header: 'Información Bancaria',
      payments__bank_name: 'Nombre del banco',
      payments__bank_routing_number:
        'Número de ruta (código de identificación bancaria)',
      payments__confirm_bank_routing_number:
        'Confirme el número de ruta (código de identificación bancaria)',
      payments__bank_routing_number_placeholder: '110000000',
      payments__card_type: 'Tipo de Tarjeta',
      payments__city: 'Ciudad',
      payments__city_placeholder: 'Seattle',
      choose__shipping_address:
        'Al seleccionar esta opción, esta dirección se convertirá en una dirección de envío. ¿Está seguro/a que quiere proceder?',
      payments__card_activation: 'Activación de Tarjeta',
      payments__cvc: 'CVC',
      payments__direct_deposit: 'Depósito Directo',
      payments__direct_deposit_to_bank_account:
        'Ingresar una cuenta bancaria de depósito directo',
      payments__dob: 'Fecha de Nacimiento',
      payments__expiration_date: 'Fecha de caducidad',
      payments__first_name: 'Su primer nombre',
      payments__first_name_placeholder: 'Jane',
      payments__email_vi_placeholder: 'Jane@gmail.com',
      payments__email_vi: 'email',
      payments__how_to_recieve_funds: '¿Cómo le gustaría recibir sus fondos?',
      payments__how_would_you_like_to_receive_your_funds:
        '¿Cómo le gustaría recibir sus fondos?',
      payments__information_header: 'Información acerca de usted',
      payments__issuing_name_confirm:
        'Favor de confirmar su nombre, esto estará ya imprimida en su tarjeta.',
      payments__last_name: 'Su apellido',
      payments__last_name_placeholder: 'Doe',
      payments__or_add_a_new_account: 'Agregar un nuevo método de pago',
      payments__physical_card: 'Tarjeta Física',
      payments__physical_debit_card: 'Pedir una tarjeta de actual',
      payments__select_an_existing_account: 'Seleccione un método de pago',
      payments__state: 'Estado',
      payments__state_placeholder: 'WA',
      payments__state_placeholder_long: 'Seleccione un Estado',
      payments__stripe_card_billing_address:
        'Su tarjeta usará este domicilio como el domicilio de la factura cuando haga compras en linea.',
      payments__stripe_card_issuing_digital:
        'Me gustaría recibir mis fondos a través de una tarjeta digital disponible de inmediato después de que se aprueba mi solicitud',
      payments__stripe_card_issuing_physical:
        'Me gustaría recibir mis fondos a través de una tarjeta física que se me enviara a mi domicilio dentro de los 6-8 días posteriores a la aprobación de mi solicitud',
      payments__user_name: 'Nombre Usuario',
      payments__user_name_placeholder: 'nombre',
      payments__view_card_details: 'Ver Detalles de la Tarjeta',
      payments__virtual_card: 'Tarjeta Virtual',
      payments__virtual_debit_card: 'Pedir una tarjeta de virtual',
      payments__paypal: 'Transferir a PayPal',
      payments__venmo: 'Transferir a Venmo',
      payments__zip: 'Código Postal',
      payments_zip_error: 'Debe contener exactamente 5 dígitos',
      payments__zip_placeholder: '98104',
      physical: 'Física',
      primary: 'Principal',
      required: 'Necesario',
      special_chars_name: 'Error: elimine los caracteres especiales',
      save: 'Guardar',
      add: 'Agregar',
      shipping: 'Para Envios',
      virtual: 'virtual',
      onboarding__error:
        'Hemos encontrado un problema. Favor de intentarlo de nuevo.',
      payments__preferred_payment_account: 'Método de recibo de pago preferido',
      payments__auto_pay_title: 'Configuración de depósito automático',
      payments__auto_pay_description:
        'Active depósitos automáticos desde su cuenta del fondo personal de UpTogether a su método de pago preferido. No tendrá que retirar manualmente los fondos de sus ofertas aceptadas o pagos por las investigaciones de cual participa.',
      payments__settings_updated: 'Ajustes Actualizados',
      payments__issuing_confirmation_title:
        'Confirme su método preferido para recibir los pagos',
      payments__issuing_confirmation_physical_1:
        'Si selecciona este método,  los futuros pagos serán transferidos a su UpTogether tarjeta física.  Puede cambiar esto en cualquier momento.',
      payments__issuing_confirmation_virtual_1:
        'Si usted elige este método, los futuros pagos serán transferidos a su UpTogether tarjeta virtual. Puede cambiar esto en cualquier momento.',
      payments__physical_cards: 'tarjetas físicas',
      payments__virtual_cards: 'tarjetas virtuales',
      payments__paypal_view: 'PayPal',
      payments__venmo_view: 'Venmo',
      payments__card: 'tarjeta',
      payments__issuing_confirmation_text_4: 'Antes de confirmar,',
      payments__issuing_confirmation_text_5:
        'por favor lea estas preguntas frecuentes',
      payments__issuing_confirmation_text_6: 'para entender como',
      payments__issuing_confirmation_text_7:
        'tarjetas pueden y no pueden ser usadas.',
      payments__issuing_confirmation_physical_2:
        'tarjetas físicas pueden y no pueden ser usadas.',
      payments__issuing_confirmation_virtual_2:
        'tarjetas virtuales pueden y no pueden ser usadas.',
      payments__issuing_confirmation_btn: 'Confirmar método de pago',
      payments_confirmation_message: 'Confirmar Método de Pago',
      security__settings_updated: 'Respuestas de seguridad actualizadas',
      dashboard__tooltip_contact:
        'Agregue métodos de contacto adicionales a su cuenta. Puede utilizar cualquiera de estos métodos de contacto para iniciar su sesión. Solo los métodos de contacto designados como "principales" recibirán las notificaciones.',
      notification_financial_updates_off_message:
        '¿Está seguro de que desea desactivar las actualizaciones financieras? Ya no recibirá avisos sobre ofertas de fondos que puedan estar disponibles para usted.',
      notification_financial_updates_off_confirm: 'Apagar',
      payments__are_you_sure: '¿Está usted seguro?',
      payments__email: 'Correo electrónico asociado con la cuenta PayPal',
      payments__phone_number:
        'Número de teléfono asociado con la cuenta de Venmo',
      payments__vi_email: 'Correo electrónico asociado con la cuenta VI PayPal',
      payments__vi_phone_number:
        'Número de teléfono asociado con la cuenta VI Venmo',
      payments__vi_venmo_phone_prefill:
        'Vaya a la página Información de contacto en su perfil y agregue el número de teléfono que usará para Venmo',
      payments__venmo_add_phone_description:
        'Por su seguridad, necesitamos verificar el número de teléfono vinculado con su cuenta de Venmo. Ingrese el número de teléfono abajo para recibir un código de verificación mediante un mensaje de texto.',
      account_creation:
        'y luego regrese a esta página para finalizar la configuración de este método de pago.',
      change_venmo_phone_number_message:
        '¿Ingresó el número de teléfono equivocado? ',
      change_phone_number: 'Ingrese el número de nuevo',
      code_receive_text: '¿No recibió el código?',
      disconnect: 'Desconectar',
      dashboard__code_confirmation: 'Ingresar Código:',
      dashboard__resend_code: 'Reenviar código',
      dashboard__send_code: 'Enviar Código',
      dashboard__sent_code_confirmation_1: 'Un código fue enviado al',
      dashboard__sent_code_confirmation_2:
        '. Por favor, verifique el número ingresando el código que usted recibió en el espacio abajo. El código expira en 5 minutos.',
      dashboard_venmo_confirm_code: 'Conéctese con Venmo',
      dashboard_enter_the_code: 'Ingrese el código',
      dashboard_venmo_one_time_code_error_status:
        'El número de código único que fue ingresado es inválido. Por favor intente de nuevo.',
      dashboard_venmo_session_expired:
        'El código que usted ingresó se ha expirado. Por favor intente de nuevo.',
      dashboard_venmo_one_time_code_expired:
        'El código que usted ingresó se ha expirado. Por favor reenvíase otro código para intentar de nuevo.',
      disabled: 'Desactivado',
      error_verifying_venmo_phone_number:
        'No pudimos verificar el número de teléfono asociado con su cuenta de Venmo. Por favor, intente de nuevo.',
      error_verifying_venmo:
        'Hubo un problema con la verificación del número de teléfono asociado con su cuenta de Venmo. Por favor, intente otra vez después.',
      one_time_code: 'Código único de Verificación',
      payment_disconnect_message_title: 'Confirme la desconexión',
      payment_disconnect_confirmation:
        '¿Usted está seguro/a de que quiere desconectar su ',
      payment_disconnect_confirmation_message:
        'Si usted opta por desconectarse, no podrá seguir recibiendo pagos a esta cuenta.',
      paypal_email_address: 'Dirección de correo electrónico',
      paypal_email_address_message:
        'para verificar el correo electrónico asociado con su cuenta PayPal para resolver cualquier problema necesario.',
      paypal_information_header: 'Información que recopilamos:',
      paypal_notification_message:
        'Su método de contacto será el predeterminado siguiente a menos que lo cambie:',
      paypal_payer_id:
        'Identidad de la cuenta de PayPal (identidad para pagos o payer ID en inglés)',
      paypal_payer_id_message:
        'para identificar su cuenta en PayPal y así poder transferir fondos.',
      paypal_verification_status: 'Estado de verificación de la cuenta',
      paypal_verification_status_message:
        'para ver si usted tiene una cuenta de Paypal verificada y con ninguna restricción.',
      paypal_account_creation_title: '¿No tiene una cuenta de Paypal?',
      paypal_account_disconnect_message: 'cuenta de PayPal?',
      sign_up: 'Primero, crea una cuenta',
      under_18_message:
        'Si usted es menor de 18 años, por favor configure la cuenta con su padre/madre o guardián como el titular primario de la cuenta.',
      venmo_add_phone_message_header: 'Número de Teléfono de Venmo',
      venmo_account_creation_title: '¿No tiene una cuenta de Venmo?',
      venmo_account_disconnect_message: 'cuenta de Venmo?',
      yes: 'Sí',
      // Payment method redesign
      payments__add_payout_method_error_message:
        'Actualmente no hay métodos de pago habilitados para esta cuenta. Vuelva a intentarlo más tarde o póngase en contacto con el soporte.',
      payments__add_payout_method: 'Añadir Método de Pago',
      payments__payout_method_subtitle: 'Elija el método que desea añadir.',
      payments__select_primary_payout_method:
        'Seleccione un Método de Pago Principal',
      payments__change_primary_payout_method: 'Cambiar el Método de Pago',
      payout_method_title_message: 'Bienvenida/o a sus Métodos de Pago',
      payout_method_subtitle1_message:
        'Vamos a tomar el tiempo para configurar su Método de Pago Principal.',
      payout_method_subtitle2_message:
        'En UpTogether su método de pago principal puede ser:',
      payout_method_direct_deposit: 'Cuenta Bancaria (Depósito Directo)',
      payout_method_debit_card:
        'Tarjeta de Débito UpTogether (Física o Virtual)',
      payout_method_account: 'Cuenta de Paypal o Venmo',
      payout_method_payment_instruction:
        'Enviaremos sus pagos a su método de pago principal.',
      payout_method_note:
        'OJO: Configurar un método de pago principal NO garantiza que se le seleccione para recibir fondos.',
      primary_payout_method_setup_message:
        '¿Listo/a para configurar su método de pago principal?',
      not_now: 'No en este momento',
      setting_up_preferred_method_title_message:
        'Configurar su Método de Pago Principal',
      setting_up_preferred_method_subtitle_message:
        'Elija el método que mejor se adapte a sus necesidades',
      payments__virtual_physical_cards: 'Tarjeta Virtual/ Física',
      payments__paypal_account: 'Cuenta PayPal',
      payments__venmo_account: 'Cuenta Venmo',
      payments__vi_reloadable_virtual_card: 'Tarjeta virtual de Uptogether',
      payments__vi_reloadable_physical_card: 'Tarjeta física de Uptogether',
      payments__vi_paypal_account: 'VI Cuenta PayPal',
      payments__vi_venmo_account: 'VI Cuenta Venmo',
      payments__vi_ach: 'ACH / Depósito Directo',
      payment__vi__address__disabled__all_1: 'Todas las direcciones están',
      payment__vi__address__disabled__some_1: 'Algunas direcciones están',
      payment__vi__address__disabled__some_2:
        'ya que superan el límite máximo de caracteres establecido por el proveedor de pagos. Por favor',
      payment__vi__address__disabled__some_3:
        'o añada una nueva dirección de envío.',
      payment__vi__address_edit: 'edite la dirección',
      payments__selection_title: 'Ha seleccionado',
      payments__method_information_message:
        'Conozca más sobre esta opción aquí',
      payments__method_card_information_message1:
        'Así es cómo aparecerá su nombre en su tarjeta',
      payments__method_card_information_message2:
        'Este es el domicilio de facturación que utilizará su tarjeta para las compras',
      back: 'Regresar',
      payments__institution_name: 'Nombre de la institución',
      payments__institution_name_placeholder: 'Banco Popular',
      payments_method_review_title_message: 'Revise su información para el',
      dashboard__payout_details: 'Detalles del Pago',
      payments__method: 'Método',
      payments__method_primary: 'Principal',
      payments__method_type: 'Tipo',
      payments__method_created: 'Fecha en que se Agregó',
      payments__bank_accountholder: 'Titular de la cuenta',
      payments__bank_account_type: 'Tipo de cuenta',
      payments_success_page_title: '¡Felicidades!',
      payments__success_page_subtitle1: 'Ha configurado con éxito su',
      payments__success_page_subtitle2: 'como método de pago.',
      payments__success_page_primary_subtitle2:
        'como su método de pago principal.',
      payments__virtual_debitcard: 'Tarjeta de Débito Virtual',
      payments__physical_debitcard: 'Tarjeta de Débito Física',
      payments__debit_card_message: 'Ha seleccionado Tarjeta de Débito',
      payments__debit_card: 'Tarjeta de Débito',
      payments__name: 'Nombre',
      payments__physical_card_message:
        '<b>OJO: Las tarjetas físicas tardan aproximadamente 10 días hábiles en llegar a la dirección que usted indique.</b>',
      continue: 'Continuar',
      payments_card_holder_name: 'SU NOMBRE AQUÍ',
      balance: 'saldo',
      payments__remove_method: 'Quitar este método',
      payments__remove_method_message:
        'Eliminar método y datos del sitio de UpTogether',
      payments__make_primary_method: 'Hacer de este el Método Principal',
      payments__make_primary_method_message:
        'Hacer que esta cuenta sea el método de pago principal',
      payments__view_details: 'Ver detalles',
      payments__view_details_message: 'Ver o editar los detalles del método',
      payments__show_card: 'Mostrar Tarjeta',
      payments__show_card_message:
        'Mostrar la información de la tarjeta de débito',
      payments__hide_card: 'Ocultar Tarjeta',
      payments__hide_card_message:
        'Ocultar la información de la tarjeta de débito',
      payments__physical_card_dispatch_message:
        'Su tarjeta física se enviará al domicilio de facturación que haya indicado. Una vez que registre su tarjeta, los detalles estarán disponibles aquí.',
      payments__vi_virtual_card_dispatch_message:
        'Cree una cuenta siguiendo el correo electrónico de Incentivo Virtual (Virtual Incentive). Una vez que se registre, los detalles de su tarjeta estarán disponibles aquí.',
      payments__vi_physical_card_dispatch_message:
        'Su tarjeta física se enviará a la dirección de envío que haya facilitado. Una vez que se registre, los detalles de su tarjeta estarán disponibles aquí.',
      financials_home: 'Inicio Finanzas',
      view_payout_method: 'Ver Método de Pago',
      payments__updated_message: '¡Sus cambios han sido modificados con éxito!',
      payments__stripe_direct_deposit_error_message:
        'No hemos podido confirmar sus datos con su institución, sus cambios no se han guardado. Confirme sus datos bancarios e inténtelo de nuevo.',
      payments__stripe_card_error_message:
        'No hemos podido confirmar sus datos, sus cambios no se han guardado.',
      payments__confirm_method: 'Confirmar el Método',
      payments__make_a_change: 'Hacer un cambio',
      payments__change_method_message1: '¿Desea cambiar su método?',
      payments__change_method_message2: 'Cancelar la configuración',
      dashboard__payout_options: 'Método de Pago',
      tool_tip_help: 'Help me find this',
      save_and_review: 'Guardar y Revisar',
      stripe_payment_error_message:
        'Parece que hubo un problema al verificar su información bancaria. Por favor, asegúrese de que los datos sean correctos.',
      payments__cvv: 'CVV',
      payments__city_validation_message: 'Por favor, ingrese una ciudad válida',
      payments__primary_account_disconnection_message:
        'Está a punto de eliminar su método principal.<br /><br /> Su método de pago ahora será por defecto el siguiente método de pago que haya indicado.<br /><br /> Si no se encuentra ningún método, tendrá que añadir otro para poder recibir fondos en el futuro. De lo contrario, corre el riesgo de perder su pago.',
      // One time application redesign
      payments__street_address:
        'Dirección de la calle /Nombre de la calle y número',
      primary_stripe_account_deletion:
        'Si desea eliminar este método, seleccione un método de pago diferente o cree uno nuevo y selecciónelo primero como principal.',
      payments_apt_number: 'Piso/Suite/Número',
      payments__switch_method: '¿Necesita cambiar de método?',
      click_here: 'Haga clic aquí',
      need_help: '¿Necesita ayuda?',
      payments__bank_account_numbers_mismatch_message:
        '¡Los números de cuenta deben coincidir!',
      payments__bank_account_numbers_length_not_in_range_message:
        'El número de cuenta debe tener entre 5 y 17 caracteres.',
      payments__routing_numbers_mismatch_message:
        '¡Los números de ruta (números de identificación bancaria) deben coincidir!',
      payments__routing_numbers_length_not_in_range_message:
        'El número de ruta (número de identificación bancaria) debe tener exactamente 9 caracteres.',
      checking_savings: 'Cheques (cuenta corriente)',
      payments__primary_method_subtitle1: 'Ha elegido',
      payments_primary_method_confirmation_message:
        '¿Está seguro/a que quiere seguir con este método?',
      payments_primary_method_disbaled_message:
        'El Método de Pago Principal actual está desactivado. Por favor, seleccione un método de pago diferente para continuar enviando la solicitud.',
      payment_setup_primary_method:
        'Por favor, configure un método de pago principal.',
      payments__direct_deposit_help_message_1:
        'Para configurar su Depósito Directo, necesitará:',
      payments__direct_deposit_help_message_2:
        'Número de cuenta de cheques corriente',
      payments__direct_deposit_help_message_3:
        'Número de ruta (código de identificación) del banco',
      payments__direct_deposit_help_message_4:
        'Una vez que el depósito directo de UpTogether se haya completado con éxito, el dinero transferido podrá utilizarse como cualquier otro fondo de su cuenta bancaria.',
      payments__issuing_card_help_message_1:
        'Las tarjetas físicas UpTogether funcionan como una tarjeta de regalo prepagada que puede ser aceptada en cualquier lugar donde se utilicen tarjetas de débito o crédito.',
      payments__issuing_card_help_message_2:
        'Esta tarjeta no se puede utilizar para realizar devoluciones de dinero en las cajas registradoras, retiros en cajeros automáticos o transferencias de dinero.',
      payments__issuing_card_help_message_3:
        'Las tarjetas físicas UpTogether se le enviará y suele tardar hasta 10 días hábiles en llegar por correo.',
      payments__issuing_card_help_message_4:
        'Las tarjetas virtuales UpTogether pueden utilizarse en línea en cualquier lugar que acepte pagos en línea con tarjetas de débito o crédito.  Esta tarjeta no se puede utilizar directamente para compras en tiendas, ni para retirar dinero de los cajeros automáticos, ni para realizar transferencias de dinero.',
      payments__issuing_card_help_message_5:
        'La tarjeta virtual UpTogether ya estará activada y los fondos suelen estar disponibles en la tarjeta en un plazo de 2 a 3 días hábiles desde su emisión.',
      payments__paypal_account_help_message_1:
        'Use su cuenta de PayPal existente o cree una ahora',
      payments__paypal_account_help_message_2:
        'Todo lo que necesita es asegurarse de que su dirección de correo electrónico sea correcta',
      payments__paypal_account_help_message_3:
        'Si tu dirección de correo electrónico vinculada a Uptogether ha cambiado, actualiza tu perfil antes de empezar',
      payments__venmo_account_help_message_1:
        'Usa tu cuenta de Venmo existente o crea una ahora',
      payments__venmo_account_help_message_2:
        'Todo lo que necesita es asegurarse de que su número de teléfono sea correcto',
      payments__venmo_account_help_message_3:
        'Si tu número de teléfono vinculado a Uptogether ha cambiado, actualiza tu perfil antes de empezar',
      payments__vi_reloadable_virtual_card_help_message_1:
        'Las tarjetas virtuales UpTogether se pueden usar donde sea que acepten pagos en línea por tarjetas de débito o de crédito.',
      payments__vi_reloadable_virtual_card_help_message_2:
        'Saldo máximo: $10,000',
      payments__vi_reloadable_physical_card_help_message_1:
        'Las tarjetas físicas  UpTogether son enviadas por correo y luego de activarse son recargables y se pueden aceptar donde sea que se pueda usar tarjetas de débito o de crédito.',
      payments__vi_reloadable_physical_card_help_message_2:
        'Las tarjetas físicas UpTogether se pueden usar para retiros en cajeros automáticos o para devoluciones de efectivo en cajas (límites de $300 por retiro y $600 por dia)',
      payments__vi_reloadable_physical_card_help_message_3:
        'Saldo máximo: $10,000',
      payments__vi_paypal_help_message_1:
        'Use su cuenta de PayPal existente o cree una ahora',
      payments__vi_paypal_help_message_2:
        'Todo lo que necesita es asegurarse de que su dirección de correo electrónico sea correcta',
      payments__vi_paypal_help_message_3:
        'Si tu dirección de correo electrónico vinculada a Uptogether ha cambiado, actualiza tu perfil antes de empezar',
      payments__vi_venmo_help_message_1:
        'Usa tu cuenta de Venmo existente o crea una ahora',
      payments__vi_venmo_help_message_2:
        'Todo lo que necesita es asegurarse de que su número de teléfono sea correcto',
      payments__vi_venmo_help_message_3:
        'Si tu número de teléfono vinculado a Uptogether ha cambiado, actualiza tu perfil antes de empezar',
      payments__vi_ach_help_message_1:
        'Las transferencias bancarias via depósitos directos necesitan prueba de identidad y el número de cuenta corriente (recomendado) o número de cuenta de ahorros.',
      payments__vi_ach_help_message_2:
        'Una vez que el depósito directo de UpTogether se complete con éxito, los fondos transferidos se pueden usar como cualquier otro fondo en su cuenta bancaria.',
      payments__name_validation_message:
        'Su nombre sólo puede contener letras.',
      payments__email_validation_message: 'Enter a valid email address.',
      dashboard__knowledgebase_document_url:
        'https://docs.google.com/document/d/1v_cVemH7SnFLl9hSdPso6RjHIfI1ploo_jWsfFE-kgE/edit',
      payments__confirmation_physical_1:
        'Si selecciona este método, los futuros pagos serán transferidos a su UpTogether tarjeta física. Puede cambiar esto en cualquier momento.',
      payments__confirmation_virtual_1:
        'Si selecciona este método, los futuros pagos serán transferidos a su UpTogether tarjeta virtual. Puede cambiar esto en cualquier momento.',
      payments__confirmation_connect_1:
        'Si selecciona este método, los futuros pagos serán transferidos a su UpTogether depósito directo. Puede cambiar esto en cualquier momento.',
      payments__confirmation_physical_2:
        'pueden y no pueden utilizarse las tarjetas físicas.',
      payments__confirmation_virtual_2:
        'pueden y no pueden utilizarse las tarjetas virtuales.',
      payments__confirmation_connect_2:
        'pueden y no pueden utilizarse las depósito directo a cuenta bancaria.',
      payments__confirmation_text_4: 'Antes de confirmar,',
      payments__confirmation_text_5:
        'por favor, lea estas preguntas frecuentes',
      payments__confirmation_text_6: 'para entender cómo',
      payments__direct_deposit_bank_account:
        'depósito directo a cuenta bancaria',
      vi_add_shipping_address: 'Añada la dirección de envío',
      smarty_address_verification_failure:
        'Hubo un error al verificar la dirección. Por favor vuelva a intentarlo más tarde.',
      smarty_address_verified_invalid:
        'No pudimos encontrar su dirección. Por favor pruebe de nuevo con una direccion de Estados Unidos. Si esto continua, por favor contáctese con el equipo de soporte.',
      return__to__application: 'Volver a la solicitud',
      set__email_to_create_vi_modalities:
        'No tiene un correo electrónico vinculado a su cuenta. Este proveedor de pagos requiere una dirección de correo para su configuración. Por favor, añada una dirección de correo electrónico a su cuenta para seguir procesando.',
      set__phone_to_create_vi_modalities:
        'No tienes un número de teléfono vinculado a tu cuenta. Este proveedor de pagos requiere un número de teléfono para configurarlo. Agregue un número de teléfono a su cuenta para continuar.',
      update_profile_settings:
        'This payment method requires first name and last name. Please update these in your profile settings and then try again.',
      profile_settings: 'Go to profile settings',
    },
  },
  isPayPalScriptLoaded: false,
  paymentProcessSteps: ['setupPreview', 'paymentMethods'],
  venmoPaymentSteps: ['phoneNumberValidation', 'successScreen'],
  paypalPaymentSteps: ['paypalAccountCreation', 'successScreen'],
  viVirtualReloadableCardSteps: [
    'personalDetails',
    'accountPreview',
    'successScreen',
  ],
  viPhysicalReloadableCardSteps: [
    'personalDetails',
    'existingAddress',
    'billingAddress',
    'accountPreview',
    'successScreen',
  ],
  viPaypalSteps: [
    'personalDetails',
    'paypalAccountCreation',
    'accountPreview',
    'successScreen',
  ],
  viVenmoSteps: ['personalDetails', 'accountPreview', 'successScreen'],
  viACHSteps: ['personalDetails', 'accountPreview', 'successScreen'],
  paymentType: undefined,
  paymentMethodEntityPaymentUuid: undefined,
  paypalAccountCreated: false,
  paymentFeatureFlags: {},
  serviceEndpoint: undefined,
  demoAccountsFeatureFlags: {},
  payoutViMemberProfile: undefined,
  hasNewSocialSiteFlag: undefined,
  removeShareAccountButtonFlag: undefined,
})

const mutations = {
  reset(state) {
    state.editAddress = {
      editing: false,
      address: undefined,
    }
    state.editPayment = {
      editing: false,
      ent: undefined,
    }
    state.selectedPayment = undefined
  },
  selectDashboardItem(state, item) {
    state.dashboardItemSelected = item
  },
  setActiveTab(state, activeTabName) {
    try {
      let activeTabNumber
      if (isNaN(activeTabName)) {
        const tabLookup = {
          applications: 0,
          profile: 1,
          address: 2,
          payments: 3,
        }
        activeTabNumber = tabLookup[activeTabName.toLowerCase()]
      } else {
        activeTabNumber = activeTabName
      }

      state.activeTab = activeTabNumber
    } catch (error) {
      console.log('switchToDashboardAndSetActiveTab: ERROR', error)
    }
  },
  setApplications(state, payload) {
    state.applications = payload
  },
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  // Managing loaders for multiple async calls happening in getPaymentProduct and getPaymentAccounts
  // REFERENCE: {https://stackoverflow.com/questions/60847647/manage-loader-spinner-for-multiple-simultaneous-async-service-calls-using-angula/61054877#61054877}

  setLoaderCounter(state, payload) {
    if (payload.key === 'product') {
      if (payload.type === 'increment') {
        ++state.loaderCounterProduct
      } else if (payload.type === 'decrement') {
        --state.loaderCounterProduct
      }
    } else if (payload.key === 'account') {
      if (payload.type === 'increment') {
        ++state.loaderCounterAccount
      } else if (payload.type === 'decrement') {
        --state.loaderCounterAccount
      }
    }
  },
  setStripeAccountStatus(state, payload) {
    const currentlyDue = payload.requirements.currently_due
    const pastDue = payload.requirements.past_due
    state.stripeAccountId = payload.id
    if (currentlyDue.length > 0 || pastDue.length > 0) {
      state.stripeAccountStatus = 'RESTRICTED'
    }
  },
  setAddresses(state, payload) {
    if (payload && payload.length > 0) {
      payload = payload.sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created)
      })
    }
    state.addresses = payload
  },
  setAddressTypes(state, payload) {
    state.addressTypes = payload
  },
  setEditAddress(state, payload) {
    state.editAddress = payload
  },

  setSelectedPayment(state, payment) {
    state.selectedPayment = { ...payment }
  },
  setPaymentProducts(state, payload) {
    state.paymentProducts = payload
  },
  setPaymentAccounts(state, payload) {
    state.paymentAccounts = payload
  },
  removePaymentAccount(state, payload) {
    state.paymentAccounts = state.paymentAccounts.filter(
      (x) => x.vendor_product !== payload
    )
  },
  setEditPayment(state, payload) {
    state.editPayment = payload
  },
  setReplacementCardConfirm(state, payload) {
    state.replacementCardConfirm = payload
  },
  setStripeCards(state, payload) {
    state.stripeCards = payload
  },
  setOnboardingSteps(state, payload) {
    state.onboarding.onboardingSteps = payload
  },
  setNewCode(state, payload) {
    state.newCode = payload
  },
  clearCode(state) {
    state.newCode = ''
  },
  setConfirmationType(state, val) {
    state.confirmationType = val
  },
  setAuthClaims(state, payload) {
    state.authClaims = payload
  },
  setPanelDisplayed(state, panelValue) {
    state.panelDisplayed = panelValue
  },
  setFamily(state, payload) {
    state.family = payload
  },
  setDemoAccountsFeatureFlags(state, payload) {
    state.demoAccountsFeatureFlags = payload
  },
  setAddNewHouseholdMember(state, payload) {
    state.addNewHouseholdMember = payload
  },
  setEditMemberUuid(state, payload) {
    state.editMemberUuid = payload
  },
  setHouseholdMembers(state, payload) {
    state.householdMembers = payload
    state.householdMembersLoaded = true
  },
  setDashboardCookie(state, authValue) {
    this.$cookies.remove('new_code')
    this.$cookies.set('new_code', authValue, {
      path: '/',
      maxAge: 60 * 5,
    })
  },
  removeDashboardCookie(state) {
    this.$cookies.remove('new_code')
  },
  setVenmoCookie(state, authValue) {
    this.$cookies.remove('venmo_code')
    this.$cookies.set('venmo_code', authValue, {
      path: '/',
      maxAge: 60 * 5,
    })
  },
  removeVenmoCookie(state) {
    this.$cookies.remove('venmo_code')
  },
  menuActive(state, bool) {
    state.menuActive = bool
  },
  setPayPalScript(state, payload) {
    state.isPayPalScriptLoaded = payload
  },
  setDob(state, val) {
    state.newDob = val
  },

  // redesign
  setPaymentType(state, payload) {
    state.paymentType = payload.type
    state.paymentMethodEntityPaymentUuid = payload.entityPaymentUuid
  },
  setPayPalAccountCreated(state, payload) {
    state.paypalAccountCreated = payload
  },
  setPaymentFeatureFlags(state, payload) {
    state.paymentFeatureFlags = payload
  },
  setServiceEndpoint(state, payload) {
    state.serviceEndpoint = payload
  },
  setPayoutViMemberProfile(state, payload) {
    state.payoutViMemberProfile = payload
  },
  setHasNewSocialSiteFlag(state, payload) {
    state.hasNewSocialSiteFlag = payload
  },
  setRemoveShareAccountButtonFlag(state, payload) {
    state.removeShareAccountButtonFlag = payload
  },
}

const actions = {
  async getMigratedServices(context, serviceDetails) {
    if (!serviceDetails.token) return
    try {
      context.commit('setLoading', { key: 'getMigratedServices', value: true })
      const objResult = []
      const headers = {
        headers: {
          Authorization: 'Bearer ' + serviceDetails.token,
        },
      }
      const URL = process.env.AUTH_URL
      const promises = []
      serviceDetails.services.forEach((service) => {
        const data = {
          entity_uuid: serviceDetails.entityUuid,
          service_name: service,
        }
        const featureFlagValue = this.$axios.post(
          URL + 'migrated-service-flag-values',
          data,
          headers
        )
        promises.push(featureFlagValue)
      })

      const results = await Promise.all(promises)

      serviceDetails.services.forEach((service, index) => {
        if (
          results &&
          results[index] &&
          results[index].data &&
          results[index].data.RESULTS &&
          results[index].data.RESULTS[0] &&
          results[index].data.RESULTS[0].value
        ) {
          objResult[service] = results[index].data.RESULTS[0].value
        }
      })

      context.commit('setServiceEndpoint', objResult)
    } catch (error) {
      console.log(error.response)
    } finally {
      context.commit('setLoading', {
        key: 'getMigratedServices',
        value: false,
      })
    }
  },
  /*
   * Hydrate Actions.  Do not execute these unless the
   * feature has been enabled.
   */
  async getPaymentProducts(context) {
    /*
      Action to retrieve potential payment methods that members may select, configure, and use
       */

    if (!context.state.features.DASHBOARD_PAYMENT_METHODS) return
    try {
      context.commit('setLoading', { key: 'getPaymentProducts', value: true })
      context.commit('setLoaderCounter', { key: 'product', type: 'increment' })
      const products = await this.$axios.$get(`/PROFILE_URL/payments/products`)

      context.commit('setPaymentProducts', products)
      return products
    } catch (error) {
      console.log(error.response)
    } finally {
      context.commit('setLoaderCounter', { key: 'product', type: 'decrement' })
      if (context.state.loaderCounterProduct === 0) {
        context.commit('setLoading', {
          key: 'getPaymentProducts',
          value: false,
        })
      }
    }
  },
  async getPaymentAccounts(context, newAccountToSelect) {
    /*
      Action to retrieve configured payment methods for a member
       */
    if (!context.state.features.DASHBOARD_PAYMENT_METHODS) return
    try {
      context.commit('setLoading', { key: 'getPaymentAccounts', value: true })
      context.commit('setLoaderCounter', { key: 'account', type: 'increment' })

      const accounts = await this.$axios.$get(
        `/PROFILE_URL/payments/product/accounts`
      )
      // Ensure accounts only has one possible option for each type
      const paypalArray = []
      const venmoArray = []
      const viVirtualCard = []
      const viPhysicalCard = []
      const viPaypalAccount = []
      const viVenmoAccount = []
      const viACHAccount = []

      for (let i = 0; i < accounts.length; i++) {
        const element = accounts[i]
        if (element.vendor_product) {
          switch (element.vendor_product.toLowerCase()) {
            case 'paypal':
              paypalArray.push(element)
              break
            case 'venmo':
              venmoArray.push(element)
              break
            case 'vi virtual reloadable card':
              viVirtualCard.push(element)
              break
            case 'vi physical reloadable card':
              viPhysicalCard.push(element)
              break
            case 'vi paypal':
              viPaypalAccount.push(element)
              break
            case 'vi venmo':
              viVenmoAccount.push(element)
              break
            case 'vi ach':
              viACHAccount.push(element)
              break
            default:
              console.log(
                'error, unknown vendor product',
                element.vendor_product
              )
              break
          }
        }
      }
      // if newAccountToSelect is epvp result, filter based on 'vendor_product' to get the ep result
      const accountToSelect = Object.hasOwn(
        newAccountToSelect,
        'entity_payment'
      )
        ? newAccountToSelect
        : accounts.filter(
            (account) =>
              account.vendor_product === newAccountToSelect.vendor_product
          )[0]
      // Only allow the FIRST array element of each
      // type to proceed.  By using push/unshift above,
      // we're pushing the non-placeholders to the front
      // of the list, and the placeholders to the back.
      const a = []

      if (paypalArray[0]) a.push(paypalArray[0])

      if (venmoArray[0]) a.push(venmoArray[0])

      if (viVirtualCard[0]) a.push(viVirtualCard[0])

      if (viPhysicalCard[0]) a.push(viPhysicalCard[0])

      if (viPaypalAccount[0]) a.push(viPaypalAccount[0])

      if (viVenmoAccount[0]) a.push(viVenmoAccount[0])

      if (viACHAccount[0]) a.push(viACHAccount[0])

      context.commit('setPaymentAccounts', a)

      // select the first account by default
      if (a.length > 0) {
        if (accountToSelect) {
          context.commit('setSelectedPayment', accountToSelect)
        } else {
          context.commit('setSelectedPayment', a[0])
        }
      }

      return a
    } catch (error) {
      console.log(error.response)
    } finally {
      context.commit('setLoaderCounter', { key: 'account', type: 'decrement' })
      if (context.state.loaderCounterAccount === 0) {
        context.commit('setLoading', {
          key: 'getPaymentAccounts',
          value: false,
        })
      }
    }
  },
  async getApplications(context) {
    if (!context.state.features.DASHBOARD_APPLICATIONS) return
    try {
      context.commit('setLoading', { key: 'getApplications', value: true })
      const apiResponse = await this.$axios.$get(`/RELIEF_URL/applications`)
      context.commit('setApplications', apiResponse)
    } catch (error) {
      console.log(error.response)
      context.commit('setApplications', [])
    } finally {
      context.commit('setLoading', { key: 'getApplications', value: false })
    }
  },
  async getAddressTypes(context) {
    if (!context.state.features.DASHBOARD_ADDRESS) return
    try {
      context.commit('setLoading', { key: 'getAddressTypes', value: true })
      const apiResponse = await this.$axios.$get(
        '/CORE_URL/profile/address/types'
      )
      context.commit('setAddressTypes', apiResponse)
    } catch (error) {
      console.log('error getting addresses', error.response)
    } finally {
      context.commit('setLoading', { key: 'getAddressTypes', value: false })
    }
  },
  async getAddresses(context) {
    if (!context.state.features.DASHBOARD_ADDRESS) return

    // If already running, dont run again.
    if (context.state.loading.getAddresses) return
    try {
      // if addressTypes are empty, go get them
      if (context.state.addressTypes.length === 0) {
        context.dispatch('getAddressTypes')
      }

      context.commit('setLoading', { key: 'getAddresses', value: true })
      const apiResponse = await this.$axios.$get('/CORE_URL/profile/address')
      context.commit('setAddresses', apiResponse)
    } catch (error) {
      console.log('error getting addresses1', error)
      console.log('error getting addresses2', error.response)
    } finally {
      context.commit('setLoading', { key: 'getAddresses', value: false })
    }
  },
  async saveAddress(context, { address, mode = '' }) {
    if (!context.state.features.DASHBOARD_ADDRESS) return

    // Update existing address
    if (address && address.address_uuid && address.address_uuid.length === 36) {
      try {
        context.commit('setLoading', { key: 'saveAddress', value: true })
        await this.$axios.$patch(
          `/CORE_URL/profile/address/${address.address_uuid}`,
          address
        )
        await context.dispatch('getAddresses')
        context.commit('setLoading', { key: 'saveAddress', value: false })

        Dialog.alert({
          title: context.state.i18n[this.app.i18n.locale].address_saved,
          message: context.state.i18n[this.app.i18n.locale].address_updated,
          confirmText: 'Ok',
        })
      } catch (error) {
        context.commit('setLoading', { key: 'saveAddress', value: false })
        Dialog.alert({
          title: context.state.i18n[this.app.i18n.locale].address_saved,
          message: error.response.data.message,
          type: 'is-danger',
          hasIcon: true,
          ariaRole: 'alertdialog',
          ariaModal: true,
        })
      } finally {
        context.commit('setLoading', { key: 'saveAddress', value: false })
      }
    } else {
      // Create new address
      try {
        context.commit('setLoading', { key: 'saveAddress', value: true })
        await this.$axios.$post('/CORE_URL/profile/address', address)
        await context.dispatch('getAddresses')

        context.commit('setLoading', { key: 'saveAddress', value: false })
        // do not show the success dialog if the save is from the onboarding process
        if (mode !== 'onboarding') {
          Dialog.alert({
            title: context.state.i18n[this.app.i18n.locale].address_saved,
            message: context.state.i18n[this.app.i18n.locale].address_updated,
            confirmText: 'Ok',
          })
        }
      } catch (error) {
        context.commit('setLoading', { key: 'saveAddress', value: false })
        Dialog.alert({
          title: context.state.i18n[this.app.i18n.locale].error,
          message: error.response.data.message,
          type: 'is-danger',
          hasIcon: true,
          ariaRole: 'alertdialog',
          ariaModal: true,
        })
      } finally {
        context.commit('setLoading', { key: 'saveAddress', value: false })
      }
    }
  },
  deleteAddress(context, address) {
    if (!context.state.features.DASHBOARD_ADDRESS) return
    Dialog.confirm({
      title: 'Confirm',
      message: `${
        context.state.i18n[this.app.i18n.locale].are_you_sure_you_want_to_delete
      } <strong>${address.friendly_name}</strong>?`,
      cancelText: context.state.i18n[this.app.i18n.locale].cancel,
      confirmText: context.state.i18n[this.app.i18n.locale].confirm,
      type: 'is-warning',
      hasIcon: true,
      ariaRole: 'alertdialog',
      ariaModal: true,
      onConfirm: async () => {
        context.commit('setLoading', { key: 'deleteAddress', value: true })

        if (address.address_uuid && address.address_uuid.length === 36) {
          try {
            this.$axios.$delete(
              `/CORE_URL/profile/address/${address.address_uuid}`
            )
            await context.dispatch('getAddresses')
          } catch (error) {
            context.commit('setLoading', {
              key: 'deleteAddress',
              value: false,
            })
            Dialog.alert({
              title: context.state.i18n[this.app.i18n.locale].error,
              message: error.response.data.message,
              type: 'is-danger',
              hasIcon: true,
              ariaRole: 'alertdialog',
              ariaModal: true,
            })
            console.log(error)
            console.log(error.response.data.message)
          } finally {
            context.commit('setLoading', {
              key: 'deleteAddress',
              value: false,
            })
          }
        }
      },
    })
  },
  /*
   * Regular actions, which should not be gated by
   * enabled feature flags.
   */
  switchToDashboardAndSetActiveTab(context, activeTabName) {
    try {
      context.commit('setActiveTab', activeTabName)
      this.$router.push({
        path: `${
          this.$i18n.locale === 'en' ? '' : '/' + this.$i18n.locale
        }/settings/payout-methods`,
      })
    } catch (error) {
      console.log('switchToDashboardAndSetActiveTab: ERROR', error)
    }
  },
  async updateEntityAuthClaims(context, args) {
    context.commit('setLoading', {
      key: 'updateEntityAuthClaims',
      value: true,
    })
    try {
      const query = `
        mutation updateEntityAuthClaims($txa: UpdateIndividualInput!) {
          me {
            entity {
              updateIndividual(entityArgs: $txa) {
                entityUuid
              }
            }
          }
        }
        `
      const variables = {
        txa: {
          entityUuid: args.entityUuid,
          entityAuthClaims: `[{'strategy': ${args.strategy}, 'auth_type': ${args.authType}, 'auth_value': ${args.authValue}, 'meta': {}}]`,
        },
      }
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
        variables,
      })
      if (response.status === 200) {
        return 'success'
      }
    } catch (error) {
      console.log('Error updating entity auth claims for user', error)
      return error
    } finally {
      context.commit('setLoading', {
        key: 'updateEntityAuthClaims',
        value: false,
      })
    }
  },
  async getOnboardingSteps({
    state,
    rootState,
    commit,
    dispatch,
    getters,
    rootGetters,
  }) {
    const stepsToBeShown = []

    commit('setLoading', { key: 'onboardingSteps', value: true })

    try {
      let address = getters.primaryAddress

      if (!address) {
        await dispatch('getAddresses')
        address = getters.primaryAddress
      }
      // To test, just add a step like so: stepsToBeShown.push('avatar')
      const identityMeta = rootGetters['fiiAuth/identityMeta']

      onboardingSchema.forEach((step) => {
        const stepName = step.name
        // get the object containing the info corresponding to the onboading step
        const objectContainingDataForTheStep = [
          'identity',
          'avatar',
          'research',
        ].includes(stepName)
          ? identityMeta
          : stepName === 'address'
          ? address
          : stepName === 'security'
          ? get(identityMeta, ['securityQuestions'])
          : undefined

        console.log('step object found', objectContainingDataForTheStep)

        if (objectContainingDataForTheStep !== undefined) {
          let containerForObjectContainingData = []
          if (Array.isArray(objectContainingDataForTheStep)) {
            containerForObjectContainingData = [
              ...objectContainingDataForTheStep,
            ]
          } else {
            containerForObjectContainingData.push(
              objectContainingDataForTheStep
            )
          }

          const minOccurence = step.minOccurence ? step.minOccurence : 1
          let iteration = 0

          do {
            // if the object is an array, check if the array has the required number of elements
            // as mentioned in the schema for the onboarding step
            if (Array.isArray(objectContainingDataForTheStep)) {
              if (containerForObjectContainingData.length < minOccurence) {
                stepsToBeShown.push(stepName)
                break
              }
            }

            step.reqFields.forEach((reqField) => {
              if (
                !containerForObjectContainingData[iteration][reqField] ||
                containerForObjectContainingData[iteration][reqField] === ''
              ) {
                if (!stepsToBeShown.includes(stepName)) {
                  stepsToBeShown.push(stepName)
                }
              }
            })
            iteration++
          } while (iteration < minOccurence && iteration < 10)
        } else {
          stepsToBeShown.push(stepName)
        }
      })
    } finally {
      commit('setLoading', { key: 'onboardingSteps', value: false })
    }

    console.log('onboarding steps to be shown', stepsToBeShown)
    commit('setOnboardingSteps', stepsToBeShown)
  },
  async sendAuthCode(context, args) {
    const { inviteType, entityUuid, authValue } = args
    const query = `
      mutation createInviteCodes($txa: CreateInviteCodeInput!) {
        me {
          inviteCodes {
            createInviteCodes(entityArgs:$txa) {
              inviteType {
                name
              }
            }
          }
        }
      }
      `
    const variables = {
      txa: {
        inviteTypeName: inviteType,
        createdByEntityUuid: entityUuid,
        invitedToEntityUuid: entityUuid,
        inviteeEntityUuid: entityUuid,
        data: JSON.stringify({ auth_claim: authValue }),
      },
    }
    try {
      context.commit('setLoading', { key: 'sendAuthCode', value: true })
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
        variables,
      })
      return response
    } catch (error) {
      console.log('error sending auth code', error)
    } finally {
      context.commit('setLoading', { key: 'sendAuthCode', value: false })
    }
  },
  async confirmAuthCode(context, args) {
    const { inviteType, entityUuid, code, authClaim } = args
    const query = `
      mutation confirmAuthCode($txa: ConsumeAuthCodeInput!) {
        me {
          inviteCodes {
            consumeAuthCode(entityArgs:$txa) {
              code
              dateCreated
            }
          }
        }
      }
      `
    const variables = {
      txa: {
        inviteTypeName: inviteType,
        code,
        entityUuid,
        entityAuthClaims: authClaim,
      },
    }
    try {
      context.commit('setLoading', { key: 'confirmAuthCode', value: true })
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
        variables,
      })
      if (inviteType === 'ENTITY_AUTH_CLAIM') {
        context.dispatch('getAuthClaims')
      }
      return response
    } catch (error) {
      console.log('error confirming auth code', error)
    } finally {
      context.commit('setLoading', { key: 'confirmAuthCode', value: false })
    }
  },
  async getAuthClaims({ commit }) {
    try {
      commit('setLoading', { key: 'getAuthClaims', value: true })
      const query = `
          query entityAuthClaims{
            me {
              entityAuthClaims {
                authValue
                authType
                status
              }
            }
          }
        `
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
      })

      const claims = get(response.data, ['data', 'me', 'entityAuthClaims'])
      const phoneClaims = []
      const emailClaims = []
      claims.forEach((el) => {
        if (el.authType === 'email' && el.status === 1) {
          emailClaims.push(el.authValue)
        }
        if (el.authType === 'phone' && el.status === 1) {
          phoneClaims.push(el.authValue)
        }
      })
      const uniquePhoneClaims = phoneClaims.filter(
        (v, i, a) => a.indexOf(v) === i
      )
      const uniqueEmailClaims = emailClaims.filter(
        (v, i, a) => a.indexOf(v) === i
      )
      commit('setAuthClaims', {
        phoneList: uniquePhoneClaims,
        emailList: uniqueEmailClaims,
      })
    } catch (error) {
      console.log('Error getting auth claims for entity', error)
    } finally {
      commit('setLoading', { key: 'getAuthClaims', value: false })
    }
  },
  async updateOnboarding({ commit, dispatch, getters }, tokenPayload) {
    try {
      commit('setLoading', { key: 'updateProfile', value: true })

      // convert camelCased object keys into
      // snake_cased for db storage
      const snakeCasedPayload = objectToSnake(tokenPayload)
      await this.$axios.$patch('/AUTH_URL/user', snakeCasedPayload)
      // refresh a token.  this will cause a profile update.
      await dispatch('fiiAuth/refreshToken', {}, { root: true })
    } catch (error) {
      console.log(error)
      Toast.open({
        message: getters.translate('onboarding__error', this.$i18n.locale),
        type: 'is-danger',
        duration: 5000,
      })
    } finally {
      commit('setLoading', { key: 'updateProfile', value: false })
    }
  },
  async createHouseholdMember(
    { state, rootState, commit, dispatch, getters, rootGetters },
    individual
  ) {
    commit('setLoading', { key: 'createHouseholdMember', value: true })

    const identity = rootState.fiiAuth.identity
    const relationshipType = individual.relationshipType
    delete individual.relationshipType

    try {
      // check if the logged in member has a household entity created
      if (state.family.length === 0) {
        console.log('creating family')
        await dispatch('createFamily')
      } else {
        console.log('family already exists, skipping family creation...')
      }

      const familyUuid = state.family[0].entityUuid
      console.log('family entity uuid', familyUuid)

      // create the individual and the "member_of" relationship to the family
      const createIndividualMutation = `
        mutation createIndividual($createIndividualArgs: CreateIndividualInput!) {
          me {
              entity {
                  createIndividual(entityArgs: $createIndividualArgs) {
                      id
                      entityUuid
                      name
                      meta
                  }
                }
            }
          }
        `

      const createIndividualInput = {
        createIndividualArgs: {
          ...individual,
          relationshipTargetEntityUuid: familyUuid,
          relationshipType: 'member_of',
        },
      }
      delete createIndividualInput.createIndividualArgs.newMember
      delete createIndividualInput.createIndividualArgs.householdMember

      const individualCreationResponse = await this.$axios.$post(
        '/GRAPHQL_URL/',
        {
          query: createIndividualMutation,
          variables: createIndividualInput,
        }
      )

      const householdMemberUuid =
        individualCreationResponse.data.me.entity.createIndividual.entityUuid
      console.log('new householdMemberUuid', householdMemberUuid)

      // create the relationship to the logged in member
      const createRelationshipInput = {
        sourceEntityUuid: identity.entityUuid,
        targetEntityUuid: householdMemberUuid,
        relationshipType,
      }

      await dispatch('createRelationship', createRelationshipInput)

      console.log('successfully created household member and relationships')
      await dispatch('getHousehold')
      commit('setEditMemberUuid', undefined)
      commit('setAddNewHouseholdMember', false)
    } catch (e) {
      console.log(e)

      Toast.open({
        message: rootGetters['payment/localizedMessage'](
          'household_add_member_error',
          this.$i18n.locale
        ),
        type: 'is-danger',
        duration: 5000,
      })
    } finally {
      commit('setLoading', { key: 'createHouseholdMember', value: false })
    }
  },
  async createRelationship(
    { state, rootState, commit, dispatch, getters, rootGetters },
    relationshipArgs
  ) {
    // create the relationship to the logged in member
    const createRelationshipMutation = `
            mutation createRelationship($createRelationshipArgs: CreateRelationshipInput!) {
              me {
                entity {
                  createRelationship(entityArgs: $createRelationshipArgs) {
                    ok
                    message
                  }
                }
              }
            }
            `

    const createRelationshipInput = {
      createRelationshipArgs: relationshipArgs,
    }

    await this.$axios.$post('/GRAPHQL_URL/', {
      query: createRelationshipMutation,
      variables: createRelationshipInput,
    })
  },
  async removeAuthClaim(context, args) {
    context.commit('setLoading', {
      key: 'removeAuthClaim',
      value: true,
    })
    try {
      const query = `
        mutation removeAuthClaim($txa: UpdateEntityAuthStatusInput!) {
          me {
            entity {
              updateEntityAuthStatus(entityArgs:$txa) {
                ok
                message
              }
            }
          }
        }
      `
      const variables = {
        txa: {
          authValue: args.authValue,
          status: 'INACTIVE',
        },
      }
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
        variables,
      })
      console.log('RESPONSE FROM REMOVAL', response)
    } catch (error) {
      console.log('error removing auth claim', error)
    } finally {
      context.commit('setLoading', {
        key: 'removeAuthClaim',
        value: false,
      })
    }
  },
  async createFamily({
    state,
    rootState,
    commit,
    dispatch,
    getters,
    rootGetters,
  }) {
    const createFamilyMutation = `
        mutation createFamily($createFamilyArgs: CreateFamilyInput!) {
          me {
            entity {
              createFamily(entityArgs: $createFamilyArgs) {
                id
                entityUuid
              }
            }
          }
        }
      `
    let address = getters.primaryAddress
    if (!address) {
      await dispatch('getAddresses')
      address = getters.primaryAddress
    }
    const identity = rootState.fiiAuth.identity

    const createFamilyArgs = {
      name: 'Family of ' + get(identity, ['meta', 'firstName']),
      relationshipTargetEntityUuid: identity.entityUuid,
      relationshipType: 'has_member',
    }
    if (address !== undefined) {
      createFamilyArgs.address = address.address1
      createFamilyArgs.city = address.city
      createFamilyArgs.state = address.state
      createFamilyArgs.zipCode = address.zip
    }

    try {
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query: createFamilyMutation,
        variables: {
          createFamilyArgs,
        },
      })

      commit('setFamily', [response.data.me.entity.createFamily])
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async getHousehold({
    state,
    rootState,
    commit,
    dispatch,
    getters,
    rootGetters,
  }) {
    try {
      commit('setLoading', { key: 'getHousehold', value: true })

      const query = `
          query getHousehold{
            me {
              entityUuid
              relationships {
                all {
                  entityUuid
                  meta
                  entityType
                  relationshipType
                }
              }
            }
          }`

      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      console.log('response.data: ', response.data)
      const allRelationships = response?.data?.me?.relationships?.all
      if (allRelationships) {
        const family = allRelationships.filter(
          (relationship) => relationship.entityType === 'family'
        )

        console.log('family: ', family)
        if (family.length > 0) {
          commit('setFamily', family)
        }
      }

      const householdMembersData = allRelationships.filter((relationship) =>
        [
          'spouse',
          'friend',
          'child_of',
          'has_child',
          'relative',
          'acquaintance',
          'sibling',
          'roommate',
          'other',
        ].includes(relationship.relationshipType)
      )
      const householdMembers = []
      householdMembersData.forEach((householdMember) => {
        console.log('householdMember: ', householdMember)
        const memberMetaStr = householdMember.meta
        let memberMeta = {}
        if (memberMetaStr) {
          memberMeta = JSON.parse(memberMetaStr)
          // parse only if the meta is a string
          if (typeof memberMeta === 'string') {
            memberMeta = JSON.parse(memberMeta)
          }
        }

        try {
          const memberDob = get(memberMeta, ['dob']).toString()

          if (typeof get(memberMeta, ['race']) === 'string') {
            memberMeta.race = JSON.parse(memberMeta.race)
          }

          let memberRace = get(memberMeta, ['race'])
          memberRace = memberRace || []

          let otherRace
          if (memberRace)
            otherRace = memberRace.find((race) => race.race === 'race_other')

          householdMembers.push({
            firstName: get(memberMeta, ['first_name']),
            lastName: get(memberMeta, ['last_name']),
            dob: memberDob, // Using raw dob from database
            entityUuid: householdMember.entityUuid,
            relationshipType: householdMember.relationshipType,
            language_preference: get(memberMeta, ['language_preference']),
            memberOtherLanguage: get(memberMeta, [
              'language_preference',
              'other',
            ]),
            gender: get(memberMeta, ['gender']),
            ethnicity: get(memberMeta, ['ethnicity']),
            race: memberRace,
            memberOtherRace: get(otherRace, ['other']),
            householdMember: true,
          })
        } catch (error) {
          console.log('Error adding householder')
        }
      })

      if (householdMembers.length > 0) {
        commit('setHouseholdMembers', householdMembers)
      }
    } catch (error) {
      console.log(error)
      Toast.open({
        message: rootGetters['payment/localizedMessage'](
          'household_gethousehold_error',
          this.$i18n.locale
        ),
        type: 'is-danger',
        duration: 5000,
      })
    } finally {
      commit('setLoading', { key: 'getHousehold', value: false })
    }
  },
  async updateMember(
    { state, rootState, commit, dispatch, getters, rootGetters },
    householdMemberProfile
  ) {
    commit('setLoading', { key: 'updateMemberProfile', value: true })

    const identity = rootState.fiiAuth.identity
    const prevRelationshipType = householdMemberProfile.prevRelationshipType
    const currentRelationshipType = householdMemberProfile.relationshipType

    const updateIndividualMutation = `
        mutation updateIndividual($updateIndividualArgs: UpdateIndividualInput!) {
          me {
            entity {
              updateIndividual(entityArgs: $updateIndividualArgs) {
                entityUuid
                entityType
                name
                meta
              }
            }
          }
        }
      `

    const updateIndividualInput = {
      updateIndividualArgs: {
        entityUuid: householdMemberProfile.entityUuid,
        firstName: householdMemberProfile.firstName,
        lastName: householdMemberProfile.lastName,
        dob: householdMemberProfile.dob,
        languagePreference: JSON.stringify(
          householdMemberProfile.language_preference
        ),
        gender: householdMemberProfile.gender,
        ethnicity: householdMemberProfile.ethnicity,
        race: JSON.stringify(householdMemberProfile.race),
      },
    }

    try {
      console.log('update meta input: ', updateIndividualInput)
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query: updateIndividualMutation,
        variables: updateIndividualInput,
      })

      // the graphql mutation returns HTTP 200 with errors if
      // the update wasn't successfull
      if (response.errors && response.errors.length > 0) {
        console.log('errors: ', response.errors.length)
        throw response.errors[0].message
      }

      // if the relationship type was changed, reconstruct the relationship
      if (prevRelationshipType !== currentRelationshipType) {
        dispatch('removeMember', householdMemberProfile.entityUuid)
        const createRelationshipInput = {
          sourceEntityUuid: identity.entityUuid,
          targetEntityUuid: householdMemberProfile.entityUuid,
          relationshipType: currentRelationshipType,
        }

        dispatch('createRelationship', createRelationshipInput)
      }

      Dialog.alert({
        title: rootGetters['payment/localizedMessage'](
          'household_success_title'
        ),
        message: rootGetters['payment/localizedMessage'](
          'household_save_member_success'
        ),
        type: 'is-info',
        hasIcon: true,
        ariaRole: 'alertdialog',
        ariaModal: true,
        onConfirm: async () => {
          await dispatch('getHousehold')
          commit('setEditMemberUuid', undefined)
          commit('setAddNewHouseholdMember', false)
        },
      })
    } catch (e) {
      console.log(e)
      throw e
    } finally {
      commit('setLoading', { key: 'updateMemberProfile', value: false })
    }
  },
  async removeMember(
    { state, rootState, commit, dispatch, getters, rootGetters },
    householdMemberUuid
  ) {
    commit('setLoading', { key: 'deleteFamilyRelationships', value: true })

    const deleteFamilyRelationshipsMutation = `
        mutation deleteFamilyRelationships($deleteFamilyRelationshipsArgs: DeleteFamilyRelationshipsInput!) {
          me {
            entity {
              deleteFamilyRelationships(entityArgs: $deleteFamilyRelationshipsArgs) {
                ok
                message
              }
            }
          }
        }
      `

    const deleteFamilyRelationshipsInput = {
      deleteFamilyRelationshipsArgs: {
        familyEntityUuid: state.family[0].entityUuid,
        houesholdMemberEntityUuid: householdMemberUuid,
      },
    }

    try {
      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query: deleteFamilyRelationshipsMutation,
        variables: deleteFamilyRelationshipsInput,
      })

      return response
    } catch (e) {
      console.log(e)
      Toast.open({
        message: getters.translate('gethousehold__error', this.$i18n.locale),
        type: 'is-danger',
        duration: 5000,
      })
    } finally {
      commit('setLoading', { key: 'deleteFamilyRelationships', value: false })
    }

    return null
  },
  async imminentPaymentStatus(context, args) {
    const { entityPaymentUuid } = args
    let response
    const query = `
        query imminentPayment($entityPaymentUuid: String!) {
        me {
          imminentPayment(entityPaymentUuid: $entityPaymentUuid) {
            result
          }
        }
      }
      `
    const variables = {
      entityPaymentUuid,
    }
    try {
      context.commit('setLoading', {
        key: 'imminentPaymentStatus',
        value: true,
      })
      response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
        variables,
      })
      context.commit('setLoading', {
        key: 'imminentPaymentStatus',
        value: false,
      })
      const hasImminentPayment = response.data.data.me.imminentPayment.result
      return hasImminentPayment
    } catch (error) {
      console.log('error getting imminent payment status', error)
    } finally {
      context.commit('setLoading', {
        key: 'imminentPaymentStatus',
        value: false,
      })
    }
  },
  async getFeatureFlags(context) {
    try {
      const result = await this.$featureFlag.isEnabled([
        { name: 'ff_new_social_site' },
        { name: 'ff_payout_paypal' },
        { name: 'ff_payout_venmo' },
        { name: 'ff_payout_vi_ach' },
        { name: 'ff_payout_vi_paypal' },
        { name: 'ff_payout_vi_physical_reloadable_card' },
        { name: 'ff_payout_vi_venmo' },
        { name: 'ff_payout_vi_virtual_reloadable_card' },
      ])
      const {
        ff_new_social_site: ffNewSocialSite,
        ff_remove_share_account_button_for_all_except_chicago: _,
        ...payoutFlags
      } = result
      context.commit('setHasNewSocialSiteFlag', ffNewSocialSite)
      context.commit('setPaymentFeatureFlags', { ...payoutFlags })
    } catch (error) {
      console.log(error)
    }
  },

  async getDemoAccountsFeatureFlags(context) {
    try {
      const result = await this.$featureFlag.isEnabled({
        name: 'ff_demo_account_payment_types',
      })
      context.commit('setDemoAccountsFeatureFlags', result)
    } catch (error) {
      console.log(error)
    }
  },
  async getPaymentFeatureFlags(context) {
    try {
      const result = await this.$featureFlag.isEnabled([
        { name: 'ff_payout_vi_physical_reloadable_card' },
        { name: 'ff_payout_vi_virtual_reloadable_card' },
        { name: 'ff_payout_vi_paypal' },
        { name: 'ff_payout_vi_venmo' },
        { name: 'ff_payout_vi_ach' },
        { name: 'ff_payout_paypal' },
        { name: 'ff_payout_venmo' },
      ])
      context.commit('setPaymentFeatureFlags', result)
    } catch (error) {
      console.log(error)
    }
  },
  async removeShareAccountButton(context) {
    if (context.state.applications === undefined) {
      await context.dispatch('getApplications')
    }

    try {
      const appFundUuids = context.state.applications.map(
        (fund) => fund.application.fund_entity_uuid
      )
      console.log(appFundUuids)
      const result = await this.$featureFlag.isEnabled({
        name: 'ff_remove_share_account_button_for_all_except_chicago',
        extra_data: {
          fund_entity_uuid: appFundUuids,
        },
      })
      context.commit(
        'setRemoveShareAccountButtonFlag',
        result.ff_remove_share_account_button_for_all_except_chicago
      )
    } catch (error) {
      console.log(error)
    }
  },
  async getPayoutViMemberProfile(context) {
    if (context.state.applications === undefined) {
      await context.dispatch('getApplications')
    }

    try {
      // Check the flag status for the list of funds we pass in extra data
      const appFundUuids = context.state.applications.map(
        (fund) => fund.application.fund_entity_uuid
      )
      const result = await this.$featureFlag.isEnabled({
        name: 'ff_payout_vi_member_profile',
        extra_data: {
          fund_entity_uuid: appFundUuids,
        },
      })
      context.commit(
        'setPayoutViMemberProfile',
        result.ff_payout_vi_member_profile
      )
    } catch (error) {
      console.log(error)
    }
  },
}

const getters = {
  loading(state) {
    return state.loading.length !== 0
  },
  serviceEndpoint(state) {
    return state.serviceEndpoint
  },
  authClaims(state) {
    return state.authClaims
  },
  paypalProduct(state) {
    if (!state.paymentProducts) return undefined
    return state.paymentProducts.find((x) => x.vendor_product === 'PayPal')
  },
  venmoProduct(state) {
    if (!state.paymentProducts) return undefined
    return state.paymentProducts.find((x) => x.vendor_product === 'Venmo')
  },
  paypalAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find((x) => x.vendor_product === 'PayPal')
  },
  venmoAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find((x) => x.vendor_product === 'Venmo')
  },
  viVirtualAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find(
      (x) => x.vendor_product === 'VI virtual reloadable card'
    )
  },
  viPhysicalAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find(
      (x) => x.vendor_product === 'VI physical reloadable card'
    )
  },
  viPaypalAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find((x) => x.vendor_product === 'VI paypal')
  },
  viVenmoAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find((x) => x.vendor_product === 'VI venmo')
  },
  viACHAccount(state) {
    if (!state.paymentAccounts) return undefined
    return state.paymentAccounts.find((x) => x.vendor_product === 'VI ACH')
  },
  primaryAddress(state) {
    if (!state.addresses) return undefined
    /* eslint-disable */
    return state.addresses.find((x) => x.address_type_id === 1)
    /* eslint-enable */
  },
  addresses(state) {
    if (!state.addresses) return undefined
    /* eslint-disable */
    return state.addresses
    /* eslint-enable */
  },
  getAvailableBalance: (state) => (cardId) => {
    if (cardId && state.stripeCards) {
      const card = state.stripeCards.find(
        (stripeCard) => stripeCard.card_id === cardId
      )
      const availableBalance = card ? card.available_balance : 0

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(availableBalance)
    }

    return '--'
  },
  translate:
    (state, getters, rootState, rootGetters) => (translationKey, locale) => {
      if (state.i18n[locale][translationKey]) {
        return state.i18n[locale][translationKey]
      } else {
        console.error(
          `dashboardStore could not find [${locale}]['${translationKey}']`
        )
        return `[${locale}]['${translationKey}']`
      }
    },
  userOnboarded(state, rootState, rootGetters) {
    // If the member is logged out and has no meta, return false; otherwise return true if onboarded is in their meta
    return get(rootGetters.fiiAuth.identity, ['meta', 'onboarded'])
  },
  profileScreenSelected: (state) => {
    const innerProfileScreens = ['contact-management']
    const panelDisplayed = state.panelDisplayed
    return innerProfileScreens.includes(panelDisplayed)
  },
  overEighteen: (state) => (dob) => {
    const year = dob.getFullYear()
    const month = dob.getMonth()
    const day = dob.getDate()
    const dobWithEighteen = new Date(year + 18, month, day)
    const today = new Date()
    return dobWithEighteen <= today
  },
  hasSpecialCharacter: (state) => (str) => {
    const reg = /[!@#$%^&*()_+=[\]{};:'\\|,.<>/?]/
    return reg.test(str)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
